/// <reference path="../../typings/tsd.d.ts" />
module warsApp.models {

    export class ObjectQueryRestrictionsModel {
        
        private currentTreeItem: models.TreeConfigurationItem;
        private systemLevel: Wars.Domain.Model.SystemLevel;
        private processConfigurationId: string;
        private objectQuery: Wars.Domain.Model.ObjectQuery;
        private restrictions: Array<Wars.Domain.Model.ObjectQueryRestriction>;
        private codeGroups:Array<Wars.Domain.Model.Codes.CodeGroup>;
        private parentRestriction: Wars.Domain.Model.ObjectQueryRestriction;
        private topLevel: boolean;
        private isAndGroup = true;
        private showPredicateHeader = false;
        private statuses: Array<services.ObjectQueryStringTuple>;
        private states: Array<services.ObjectQueryStringTuple>;
        private processTypes: Array<services.ObjectQueryStringTuple>;
        private processSubTypes: Array<services.ObjectQueryStringTuple>;
        private reviewConfigurations: Array<services.ObjectQueryStringTuple>;
        private reviewTypes: Array<services.ObjectQueryStringTuple>;
        private assignmentClaims: Array<services.ObjectQueryStringTuple>;
        
        constructor(private scope: directives.IObjectQueryRestrictionsScope,
            private growlService: angular.growl.IGrowlService,
            private systemLevelService: services.SystemLevelService,
            private applicationCodeService: services.ApplicationCodeService,
            private treeService: services.TreeService,
            private objectQueryService: services.ObjectQueryService) {
            var self = this;
            self.processConfigurationId = self.scope.processConfigurationId;
            self.objectQuery = self.scope.objectQuery;
            self.parentRestriction = self.scope.parentRestriction;
            self.topLevel = self.scope.topLevel;
            self.statuses = objectQueryService.getStatuses();
            self.states = objectQueryService.getStates();
            self.processTypes = objectQueryService.getProcessTypes();
            self.processSubTypes = objectQueryService.getProcessSubTypes();
            self.reviewConfigurations = objectQueryService.getReviewConfigurations();
            self.reviewTypes = objectQueryService.getReviewTypes();
            self.assignmentClaims = objectQueryService.getClaims();
            self.restrictions = self.getChildRestrictions(null);
            if (self.parentRestriction != null && self.parentRestriction.restrictionType === "D") {
                self.isAndGroup = false;
            }
        }


        getChildRestrictions(restriction: Wars.Domain.Model.ObjectQueryRestriction) {
            var self = this;
            self.showPredicateHeader = false;
            if (restriction == null) {
                restriction = self.parentRestriction;
            }
            var l: Array<Wars.Domain.Model.ObjectQueryRestriction>;
            if (restriction != null) {
                l = Enumerable
                    .from(self.objectQuery.restrictions)
                    .where(i => i.parentRestriction_id === restriction.id)
                    .toArray();
            } else {
                l = Enumerable
                    .from(self.objectQuery.restrictions)
                    .where(i => i.myParentRestriction == null)
                    .toArray();    
            }
            for (var x = 0; x < l.length; x++) {
                if (l[x].restrictionType === "P") {
                    self.showPredicateHeader = true;
                    self.loadCodes(<models.ObjectQueryPredicate>l[x]);
                    (<models.ObjectQueryPredicate>l[x]).states = self.objectQueryService.getStates();
                    (<models.ObjectQueryPredicate>l[x]).statuses = self.objectQueryService.getStatuses();
                    (<models.ObjectQueryPredicate>l[x]).processTypes = self.objectQueryService.getProcessTypes();
                    (<models.ObjectQueryPredicate>l[x]).processSubTypes = self.objectQueryService.getProcessSubTypes();
                    (<models.ObjectQueryPredicate>l[x]).reviewConfigurations = self.objectQueryService.getReviewConfigurations();
                    (<models.ObjectQueryPredicate>l[x]).reviewTypes = self.objectQueryService.getReviewTypes();
                    (<models.ObjectQueryPredicate>l[x]).assignmentClaims = self.objectQueryService.getClaims();
                    (<models.ObjectQueryPredicate>l[x]).setValidValues(self.processConfigurationId != null);
                }
            }
            return l;
        }

        addNewPredicate() {
            var self = this;
            self.objectQueryService.createNewPredicate(self.objectQuery, self.parentRestriction);
            self.restrictions = self.getChildRestrictions(null);
            self.save(null);
        }

        addNewAndGroup() {
            var self = this;
            self.objectQueryService.createNewAndGroup(self.objectQuery, self.parentRestriction);
            self.restrictions = self.getChildRestrictions(null);
            self.save(null);
        }

        addNewOrGroup() {
            var self = this;
            self.objectQueryService.createNewOrGroup(self.objectQuery, self.parentRestriction);
            self.restrictions = self.getChildRestrictions(null);
            self.save(null);
        }

        save(callback: any) {
            var self = this;
            self.objectQueryService.saveAllChanges(() => {
                if (callback != null) {
                    callback();
                }
            });
        }
        
        propertyTypeChange(predicate: models.ObjectQueryPredicate) {
            var self = this;
            var column: ExtendedQueryColumn;
            if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment ||
                predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation ||
                predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory ||
                predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                //initializers
                column = predicate.getExtendedQueryColumn();
                if (column == null) {
                    if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                        predicate.reportDataSubTableColumnName = "ClaimDefinitionUniqueIdentifier";
                        predicate.reportDataSubTableSystemColumnName = "SystemClaimGroupId";
                    }
                    if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                        predicate.reportDataSubTableColumnName = "ReviewConfigurationUniqueId";
                        predicate.reportDataSubTableSystemColumnName = "SystemReviewGroupId";
                    }
                    if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                        predicate.reportDataSubTableColumnName = "ProcessLevelStatusUniqueIdentifier";
                        predicate.reportDataSubTableSystemColumnName = "SystemLevelStatusUniqueIdentifier";
                    }
                    if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                        predicate.reportDataSubTableColumnName = "ReviewConfigurationUniqueId";
                        predicate.reportDataSubTableSystemColumnName = "SystemReviewGroupId";
                    }
                    self.queryMapColumnChange(predicate);
                }
            } else {
                predicate.reportDataSubTableColumnName = null;
                predicate.reportDataSubTableSystemColumnName = null;
            }
            if (predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                predicate.leftReportDataTreeItem = null;
                if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                    || predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                    || predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory
                    || predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                    column = predicate.getExtendedQueryColumn();
                    if (column.dataType !== ExtendedQueryColumnDataType.User
                        && column.dataType !== ExtendedQueryColumnDataType.UserEmail
                        && column.dataType !== ExtendedQueryColumnDataType.Date) {
                        predicate.rightParameterTreeItem = null;
                    }
                } else
                {
                    if (predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy &&
                        predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy &&
                        predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate &&
                        predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                        predicate.rightParameterTreeItem = null;
                    } else {
                        if (predicate.rightRestrictionType !==
                            Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.PlaceHolder) {
                            if (predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate &&
                                predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                                predicate.rightParameterTreeItem = null;  
                            }
                        }  
                    }
                }
                predicate.codeValueUniqueIdentifier = null;
                if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId || predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId) {
                    if (predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.In
                        && predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.NotIn) {
                        predicate.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.In;
                    }
                    predicate.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.SubQuery;
                } else {
                    if (predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.In
                        && predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.NotIn
                        && predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals
                        && predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.NotEqual) {
                        if (predicate.rightRestrictionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Calculation) {
                            if (predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate &&
                                predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                                var reset = true;
                                if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                                    column = predicate.getExtendedQueryColumn();
                                    if (column.dataType === ExtendedQueryColumnDataType.String) {
                                        reset = false;
                                    }
                                }
                                if (reset) {
                                    predicate.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals;
                                    predicate.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue;    
                                }
                            }
                        }
                    }
                    if (predicate.rightRestrictionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue
                        && predicate.rightRestrictionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterList
                        && predicate.rightRestrictionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Value
                        && predicate.rightRestrictionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.SubQuery) {

                        if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation ||
                            predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment ||
                            predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory ||
                            predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                            if (column.dataType !== ExtendedQueryColumnDataType.User
                                && column.dataType !== ExtendedQueryColumnDataType.UserEmail
                                && column.dataType !== ExtendedQueryColumnDataType.Date) {
                                predicate.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals;
                                predicate.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue;
                            }
                        } else {

                            if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy ||
                                predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy) {
                                if (predicate.rightRestrictionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.PlaceHolder ||
                                    (predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals &&
                                    predicate.operatorType !== Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.NotEqual)) {
                                    predicate.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals;
                                    predicate.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue;
                                }
                            } else if (predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate &&
                                predicate.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                                predicate.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals;
                                predicate.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue;    
                            }

                                
                        }
                    }
                }
                if (predicate.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Value) {
                    if ((predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State || (column != null && column.dataType === ExtendedQueryColumnDataType.State))
                        && predicate.stateUniqueIdentifier == null) {
                        predicate.stateUniqueIdentifier = self.states[0].value;
                    }
                    if ((predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status || (column != null && column.dataType === ExtendedQueryColumnDataType.Status))
                        && predicate.statusUniqueIdentifier == null) {
                        predicate.statusUniqueIdentifier = self.statuses[0].value;
                    }
                    if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType && predicate.processType_id == null) {
                        predicate.processType_id = self.processTypes[0].value;
                    }
                    if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType && predicate.processSubType_id == null) {
                        predicate.processSubType_id = self.processSubTypes[0].value;
                    }
                    if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewConfiguration && predicate.reviewConfigurationIdentifier == null) {
                        predicate.reviewConfigurationIdentifier = self.reviewConfigurations[0].value;
                    }
                    if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewType && predicate.reviewTypeIdentifier == null) {
                        predicate.reviewTypeIdentifier = self.reviewTypes[0].value;
                    }
                    if (column != null && column.dataType === ExtendedQueryColumnDataType.Claim && predicate.assignmentClaimIdentifier == null) {
                        predicate.assignmentClaimIdentifier = self.assignmentClaims[0].value;
                    }    
                }
                predicate.setValidValues(self.processConfigurationId != null);
            } else {
                predicate.showValueTarget = false;
                predicate.showParameterName = false;
                predicate.showParameterTarget = false;
            }
            self.save(null);
        }

        booleanValueChange(predicate: models.ObjectQueryPredicate) {
            var self = this;
            if (predicate.transientBooleanValue === "1") {
                predicate.booleanValue = true;
            } else {
                predicate.booleanValue = false;
            }
            self.save(null);
        }

        queryMapColumnChange(predicate: models.ObjectQueryPredicate) {
            var self = this;
            self.objectQueryService.onObjectQueryModified(predicate.myObjectQuery);
            var column = predicate.getExtendedQueryColumn();
            predicate.reportDataSubTableSystemColumnName = column.systemColumn;
            predicate.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.Equals;
            predicate.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue;
            predicate.onLeftPredicateChange(self.processConfigurationId != null);
            if (predicate.stateChange === ObjectQueryPredicateStateChange.LeftPredicate) {
                self.save(null);
                predicate.stateChange = ObjectQueryPredicateStateChange.LeftPredicate;
            }
        }

        operatorChange(predicate: models.ObjectQueryPredicate) {
            var self = this;
            predicate.onOperatorChange(self.processConfigurationId != null);
            if (predicate.stateChange === ObjectQueryPredicateStateChange.Operator) {
                self.save(null);
                predicate.stateChange = ObjectQueryPredicateStateChange.LeftPredicate;
            }
        }

        restrictionTypeChange(predicate: models.ObjectQueryPredicate) {
            var self = this;
            if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                || predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                || predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                var column = predicate.getExtendedQueryColumn();
                if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewConfiguration && predicate.reviewConfigurationIdentifier == null) {
                    predicate.reviewConfigurationIdentifier = self.reviewConfigurations[0].value;
                }
                if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewType && predicate.reviewTypeIdentifier == null) {
                    predicate.reviewTypeIdentifier = self.reviewTypes[0].value;
                }
                if (column != null && column.dataType === ExtendedQueryColumnDataType.Claim && predicate.assignmentClaimIdentifier == null) {
                    predicate.assignmentClaimIdentifier = self.assignmentClaims[0].value;
                }    
            }
            if (predicate.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                predicate.onRightRestrictionTypeChange(self.processConfigurationId != null);
                if (predicate.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Value) {
                    if (predicate.codeValueUniqueIdentifier == null) {
                        if (predicate.codes != null && predicate.codes.length > 0) {
                            predicate.codeValueUniqueIdentifier = predicate.codes[0].uniqueIdentifier;
                        }
                    }
                }
                if (predicate.stateChange === ObjectQueryPredicateStateChange.RightRistrictionType) {
                    self.save(null);
                    predicate.stateChange = ObjectQueryPredicateStateChange.LeftPredicate;
                }
            } else {
                predicate.onRightRestrictionTypeChange(self.processConfigurationId != null);
                self.save(null);
            }
        }

        deleteRestriction(restriction: Wars.Domain.Model.ObjectQueryRestriction) {
            var self = this;
            self.cascadeDeleteRestriction(restriction);
            self.save(() => {
                self.restrictions = self.getChildRestrictions(null);
            });
        }

        onDragOverRestrictionProperty($event: angular.IAngularEvent, restriction: models.ObjectQueryPredicate) {
            //TODO - Remove if not needed
        }

        onDropRestrictionProperty($event: angular.IAngularEvent, restriction: models.ObjectQueryPredicate) {
            var self = this;
            var droppedTreeItem = self.treeService.getTreeConfigurationItem();
            //only report source (indexed form feilds and variables) are valid for left side restrictions
            if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField
                && droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable) {
                self.growlService.error("Only a form field or system variable can be dropped here.");
                return;
            }
            //if (droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessId) {
            //    var apis = self.getApiActions(restriction);
            //    if (apis == null || apis.length === 0) {
            //        self.growlService.error("A process ID field requires a valid API object query configuration.");
            //        return;
            //    } 
            //}
            var treeItem = self.treeService.createTreeItemFromItemDropped();
            restriction.leftReportDataTreeItem = treeItem;
            self.objectQueryService.onObjectQueryModified(restriction.myObjectQuery);
            self.loadCodes(restriction);
            if (droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessId) {
                restriction.rightRestrictionType = Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.SubQuery;
                restriction.operatorType = Wars.Domain.Model.Codes.Enums.ObjectQueryRestrictionOperatorType.In;
                var api = self.getApiActions(restriction)[0];
                restriction.apiAction_id = api.id;
                restriction.apiActionProcessType_id = api.processTypeId;
            } else {
                restriction.apiAction_id = null;
                restriction.apiActionProcessType_id = null;
                restriction.onLeftPredicateChange(self.processConfigurationId != null);
            }
            if (restriction.stateChange === ObjectQueryPredicateStateChange.LeftPredicate) {
                self.save(null);    
                restriction.stateChange = ObjectQueryPredicateStateChange.LeftPredicate;
            }
        }

        loadCodes(restriction: models.ObjectQueryPredicate) {
            var self = this;
            if (restriction.leftReportDataTreeItem === null) return;
            if (restriction.leftReportDataTreeItem.schemaProperty === null) return;
            if (restriction.leftReportDataTreeItem.schemaProperty.codeGroup_id === null) return;

            var codeGroupId = restriction.leftReportDataTreeItem.schemaProperty.codeGroup_id;
            self.applicationCodeService.getApplicationCodesForConfiguration(codeGroupId, false).then((codes) => {
                restriction.codes = codes;
            });
        }
        
        setDefaultParameterName(restriction: models.ObjectQueryPredicate) {
            var self = this;
            var column: ExtendedQueryColumn;
            if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                restriction.parameterName = self.getTreeItemName(restriction.leftReportDataTreeItem);
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessInitiator) {
                restriction.parameterName = "[Process Initiator]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State) {
                restriction.parameterName = "[Current State]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy) {
                restriction.parameterName = "[Current State Updated By]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate) {
                restriction.parameterName = "[Current State Updated Date]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status) {
                restriction.parameterName = "[Current Status]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy) {
                restriction.parameterName = "[Current Status Updated By]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                restriction.parameterName = "[Current Status Updated Date]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType) {
                restriction.parameterName = "[Process Type]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType) {
                restriction.parameterName = "[Process Sub-Type]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Assignmnet] [${column.displayName}]`;
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Review Information] [${column.displayName}]`;
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Status History] [${column.displayName}]`;
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Comment Information] [${column.displayName}]`;
            }
            self.save(null);
        }

        getSubQueries(restriction: models.ObjectQueryPredicate): Array<Wars.Domain.Model.ObjectQuery> {
            var self = this;
            return Enumerable.from(self.objectQueryService.subQueries).where(i => i.id !== restriction.myObjectQuery.id).orderBy(i => i.name).toArray();
        }

        getProcessIdSubQueries(restriction: models.ObjectQueryPredicate): Array<Wars.Domain.Model.ObjectQuery> {
            var self = this;
            return Enumerable.from(self.objectQueryService.processIdSubQueries).where(i => i.id !== restriction.myObjectQuery.id).orderBy(i => i.name).toArray();
        }

        getApiActions(restriction: models.ObjectQueryPredicate): Array<services.ObjectQueryApiAction> {
            var self = this;
            return self.objectQueryService.apiActions;
        }

        setApiAction(restriction: models.ObjectQueryPredicate) {
            var self = this;
            var apis = self.objectQueryService.apiActions;
            for (var i = 0; i < apis.length; i++) {
                if (apis[i].id === restriction.apiAction_id) {
                    restriction.apiActionProcessType_id = apis[i].processTypeId;
                    break;
                }
            }
            self.save(null);
        }

        onDragOverRestrictionParameter($event: angular.IAngularEvent, restriction: models.ObjectQueryPredicate) {
            //TODO - Remove if not needed
        }

        onDropRestrictionParameter($event: angular.IAngularEvent, restriction: models.ObjectQueryPredicate) {
            var self = this;
            var droppedTreeItem = self.treeService.getTreeConfigurationItem();
            if (restriction.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Property) {
                //form or system variable
                if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField
                    && droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable) {
                    self.growlService.error("Only a form field or system variable can be dropped here.");
                    return;
                }
            }
            if (restriction.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Constant) {
                //constant
                if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Constant) {
                    self.growlService.error("Only a constant can be dropped here.");
                    return;
                }
            }
            if (restriction.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.PlaceHolder) {
                //place holder
                if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder) {
                    self.growlService.error("Only a place holder can be dropped here.");
                    return;
                }
            }
            if (restriction.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Calculation) {
                //place holder
                if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Calculation) {
                    self.growlService.error("Only a Calculation can be dropped here.");
                    return;
                }
            }
            if (restriction.rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.SubQuery) {
                //sub query
                self.growlService.error("Only a object query can be dropped here.");
                return;
            }
            var treeItem = self.treeService.createTreeItemFromItemDropped();

            if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property &&
                treeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Claim) {

            } else {
                if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                    if (!((restriction.leftReportDataTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Date ||
                        restriction.leftReportDataTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) &&
                        (treeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Date ||
                            treeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime))) {
                        if (restriction.leftReportDataTreeItem.variableType !== treeItem.variableType) {
                            self.growlService.error("The left and right side variable types are not the same.");
                            return;
                        }
                    }
                    //else if (restriction.leftReportDataTreeItem.variableType !== treeItem.variableType) {
                    //    self.growlService.error("The left and right side variable types are not the same.");
                    //    return;
                    //}    
                }    
            }

            
            if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment ||
                restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                var column = restriction.getExtendedQueryColumn();
                if (column.dataType === ExtendedQueryColumnDataType.User) {
                    if (treeItem.variableType !== Wars.Domain.Model.Codes.Enums.VariableType.User) {
                        self.growlService.error("The only valid placeholders are those with a variable type User.");
                        return;
                    }    
                }
            }
            restriction.rightParameterTreeItem = treeItem;
            self.objectQueryService.onObjectQueryModified(restriction.myObjectQuery);
            restriction.codeValueUniqueIdentifier = null;
            restriction.parameterName = null;
            restriction.parameterSchemaPropertyUniqueId = null;
            restriction.apiAction_id = null;
            restriction.apiActionProcessType_id = null;
            self.save(null);
        }
        
        getTreeItemName(treeItem: Wars.Domain.Model.TreeItem) {
            var self = this;
            var parentName = self.treeService.getParentDisplayName(treeItem);
            return parentName == null
                ? `[${self.treeService.getDisplayName(treeItem)}]`
                : `[${parentName}] [${self.treeService.getDisplayName(treeItem)}]`;
        }

        private cascadeDeleteRestriction(restriction: Wars.Domain.Model.ObjectQueryRestriction) {
            var self = this;
            restriction.entityAspect.setDeleted();
            var childRestrictions = self.getChildRestrictions(restriction);
            if (childRestrictions.length > 0) {
                for (var i = 0; i < childRestrictions.length; i++) {
                    self.cascadeDeleteRestriction(childRestrictions[i]);
                }
            }
        }
    }
}